module.exports = __webpack_public_path__ + "img/Station Types_02.feeeaeff.jpg";